import { FundriseRouteConfig } from 'vue-router';
import { investmentEntity } from '@store/modules/investment-entity';
import { orderForm } from '@store/modules/order-form';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const startInvestingRoutes: FundriseRouteConfig = {
	path: `/start-investing`,
	name: 'start-investing',
	meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
	component: () =>
		import(/* webpackChunkName: "start-investing" */ '@views/shopping-experience/shopping-experience.vue'),
	redirect: { name: 'select-service-level' },
	children: [
		{
			path: `initial-account-level`,
			name: 'select-service-level',
			meta: {
				step: 1,
				minTokenScopeRequired: 'UNAUTHENTICATED'
			},
			beforeEnter: async (to, from, next) => {
				if (investmentEntity.isIraEntity) {
					orderForm.UPDATE_SERVICE_LEVEL('CORE');
					next({ name: 'core-plan' });
				} else {
					next();
				}
			},
			component: () =>
				import(/* webpackChunkName: "account-level" */ '@views/shopping-experience/select-service-level.vue')
		},
		{
			path: `core-plan`,
			name: 'core-plan',
			meta: {
				step: 2,
				minTokenScopeRequired: 'UNAUTHENTICATED'
			},
			beforeEnter: async (to, from, next) => {
				if (orderForm.serviceLevel === null) {
					next({ name: 'select-service-level' });
				} else {
					next();
				}
			},
			component: () =>
				import(/* webpackChunkName: "core-plan" */ '@views/shopping-experience/select-core-plan.vue')
		}
	]
};

export default startInvestingRoutes;
